import http from '../../../Services/api.laravel.http';

export const dailySalesService = {
    dailySalesChecker: (formdata) =>
        http.post('/admin/daily/daily-sales/sales-checker', formdata),
    getDailySales: (formdata) =>
        http.post('/admin/daily/daily-sales', formdata),
    checkReport: (id) => http.get(`/admin/daily/daily-sales/job-status/${id}`),
};
